import { Phone16 } from '@cian/ui-kit/prev';
import * as React from 'react';

import * as styles from './styles.css';

type TChatHeaderCallButton = {
  phone: string;
  onClick: () => void;
};

export const ChatHeaderCallButton: React.VFC<TChatHeaderCallButton> = ({ phone, onClick }) => {
  return (
    <a href={phone} className={styles['call_button']} onClick={onClick} data-testid="call_button">
      <Phone16 color="gray60_100" />
    </a>
  );
};
